'use client';
import { useEffect, useCallback } from 'react';
import { usePathname } from 'next/navigation';
import analytics, { AnalyticsEvent } from './index';

/**
 * Hook for using Google Analytics in components
 * @param measurementId - The Google Analytics measurement ID (G-XXXXXXXXXX)
 * @returns Object with trackEvent function
 */
export function useAnalytics(measurementId: string) {
  const pathname = usePathname();
  
  // Initialize analytics on mount
  useEffect(() => {
    analytics.initialize(measurementId);
  }, [measurementId]);
  
  // Track page views when pathname changes
  useEffect(() => {
    if (pathname) {
      analytics.trackPageView(pathname);
    }
  }, [pathname]);
  
  // Function to track custom events
  const trackEvent = useCallback((event: AnalyticsEvent) => {
    analytics.trackEvent(event);
  }, []);
  
  return { trackEvent };
}

export default useAnalytics;